import Api from '@/services/Api'
// import { log } from 'util';

export default {
  testping() {
    return Api().get('mer/testping')
  },
  testams(query) {
    return Api().get('mer/testams', {
      params: query
    })
  },
  testxml(doc) {
    return Api().post('mer/testxml', doc)
  },
  sendxml(doc) {
    return Api().post('mer/sendxml', doc)
  },
  getxml(query) {
    return Api().get('mer/getxml', {
      params: query
    })
  },
  getvisualxml(query) {
    return Api().get('mer/getvisualxml', {
      params: query
    })
  },
  getulazni(query) {
    return Api().get('mer/getulazni', {
      params: query
    })
  },
  getizlazni(query) {
    return Api().get('mer/getizlazni', {
      params: query
    })
  },
  getstatusdok(query) {
    return Api().get('mer/getstatusdok', {
      params: query
    })
  },
  promjenastatus(doc) {
    return Api().post('mer/promjenastatus', doc)
  },

  // eizvjestavanje
  evidentirajdokument(doc) {
    return Api().post('mer/evidentirajdokument', doc)
  },
  oznacinaplacenid(doc) {
    return Api().post('mer/oznacinaplacenid', doc)
  },
  oznacinaplacen(doc) {
    return Api().post('mer/oznacinaplacen', doc)
  },
  oznaciodbijenid(doc) {
    return Api().post('mer/oznaciodbijenid', doc)
  },
  oznaciodbijen(doc) {
    return Api().post('mer/oznaciodbijen', doc)
  },
  eizvjestavanjereport(search) {
    return Api().get('mer/eizvjestavanjereport', {
      params: search
    })
  }
}